import React from 'react'
import { Box, Theme, useMediaQuery } from '@mui/material'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'

export type Advantage = {
  image: string
  alt: string
  title?: string
  text: string
}

type Props = {
  advantages: Advantage[]
}

const AdvantagesContainer: React.FC<Props> = ({ advantages }) => {
  const isLowerThanLg = useMediaQuery((theme: Theme) => theme.breakpoints.down('lg'))
  const isBetweenLgAndXl = useMediaQuery((theme: Theme) => theme.breakpoints.between('lg', 'xl'))

  const hasTitle = Boolean(advantages[0]?.title)

  const getTextSection = (advantage: Advantage) => {
    if (hasTitle) {
      return (
        <Box maxWidth="250px">
          <h4
            className="fs-21 fw-400 ff-new-kansas m-0"
            dangerouslySetInnerHTML={{ __html: advantage.title as string }}
            style={{ marginBottom: '16px' }}
          />
          <span className="fs-14" dangerouslySetInnerHTML={{ __html: advantage.text }} />
        </Box>
      )
    }

    return (
      <Box display="flex" gap="8px" maxWidth="250px">
        <CheckCircleIcon sx={{ fill: '#159312' }} />
        <span className="fs-14" dangerouslySetInnerHTML={{ __html: advantage.text }} />
      </Box>
    )
  }

  if (isLowerThanLg) {
    return (
      <Box display="flex" gap="32px" flexWrap="wrap" flexDirection="column">
        {advantages.map((advantage, index) => (
          <Box key={index} maxWidth="344px">
            <Box display="flex">
              {!hasTitle && <Box width="32px" />}
              <img
                style={{ width: 'auto', height: '100px', objectFit: 'contain', marginBottom: '16px' }}
                src={advantage.image}
                alt={advantage.alt}
              />
            </Box>
            {getTextSection(advantage)}
          </Box>
        ))}
      </Box>
    )
  }

  if (isBetweenLgAndXl) {
    return (
      <Box display="flex" gap="32px" flexWrap="wrap" flexDirection="column">
        {advantages.map((advantage, index) => (
          <Box key={index} display="flex" gap="32px" alignItems="center">
            <Box flex="0 0 180px" height="114px">
              <img style={{ width: '100%', height: '100%', objectFit: 'contain' }} src={advantage.image} alt={advantage.alt} />
            </Box>
            {getTextSection(advantage)}
          </Box>
        ))}
      </Box>
    )
  }

  return (
    <Box display="flex" gap="32px" flexWrap="wrap">
      {advantages.map((advantage, index) => (
        <Box key={index} maxWidth="220px">
          <Box display="flex" width="100%" height="180px" mb="24px">
            <Box flexBasis="32px" />
            <Box flex="1" height="100%">
              <img style={{ width: '100%', height: '100%', objectFit: 'contain' }} src={advantage.image} alt={advantage.alt} />
            </Box>
          </Box>
          {getTextSection(advantage)}
        </Box>
      ))}
    </Box>
  )
}

export default AdvantagesContainer
